/** The world the child is in right now (set by WowHost from the route; read by music + celebrations). */
import { create } from 'zustand';
import type { PathId } from '@sketchling/core';

export const useWorldNow = create<{ world: PathId }>(() => ({ world: 'intro' }));
